import { query, request } from '@/utils/request';
/**
 * 获取配置项
 * @param data
 * @returns
 */
export function getIncomeConfig(data) {
  return request('/zlb/budget/api/income/apply-form/common/select-config', {
    data,
    method: 'POST',
  });
}

/**
 * 获取分类选择
 * @param type 0 => 所有， 1 => 获取启用状态分类
 * @returns
 */
export function getIncomeCategorySelectValue(type) {
  return request(`/zlb/budget/api/income/category/select-value/${type}`);
}

/**
 * 分类类型列表
 * @param data
 * @returns
 */
export function getIncomeCategory(data) {
  return request('/zlb/budget/api/income/category/paging', {
    data,
    method: 'POST',
  });
}
/**
 * 保存分类类型
 * @param data
 * @returns
 */
export function saveIncomeCategory(data) {
  return request('/zlb/budget/api/income/category/save', {
    data,
    method: 'POST',
  });
}

/**
 * 登记列表
 * @param data
 * @returns
 */
export function getIncomeData(data) {
  return request('/zlb/budget/api/income/apply-form/paging', {
    data,
    method: 'POST',
  });
}

/**
 * 登记列表
 * @param data
 * @returns
 */
export function getIncomeAuditList(data) {
  return request('/zlb/budget/api/income/apply-form/audit-list', {
    data,
    method: 'POST',
  });
}

/**
 * 登记列表
 * @param data
 * @returns
 */
export function getAllIncomeList(data) {
  return request('/zlb/budget/api/income/apply-form/query-form', {
    data,
    method: 'POST',
  });
}
/**
 * 获取单据详情(申请人)
 * @param data
 * @returns
 */
export function getIncomeDetail(params) {
  return request('/zlb/budget/api/income/apply-form/info', {
    params,
  });
}

/**
 * 获取单据详情(审批人)
 * @param data
 * @returns
 */
export function getIncomeAuditDetail(params) {
  return request('/zlb/budget/api/income/apply-form/info-on-audit', {
    params,
  });
}

/**
 * 删除分类
 * @param data
 * @returns
 */
export function delIncomeCategory(data) {
  return request('/zlb/budget/api/income/category/delete', {
    data,
    method: 'POST',
  });
}

/**
 * 更新分类状态  0-启用，1-停用
 * @param data
 * @returns
 */
export function updateIncomeCategory(data) {
  return request('/zlb/budget/api/income/category/update', {
    data,
    method: 'POST',
  });
}

/**
 * 保存收入登记
 * @param data
 * @returns
 */
export function saveIncome(data) {
  return request('/zlb/budget/api/income/apply-form/save', {
    data,
    method: 'POST',
  });
}

/**
 * 删除分类
 * @param data
 * @returns
 */
export function delIncome(data) {
  return query('/zlb/budget/api/income/apply-form/delete', {
    data,
    method: 'POST',
  });
}

// 审核人更新单据
export function updateForm(data) {
  return request('/zlb/budget/api/income/apply-form/update', {
    data,
    method: 'POST',
  });
}

// 收入登记提交
export function submitIncome(data) {
  return request('/zlb/budget/api/income/apply-form/submit', {
    data,
    method: 'POST',
  });
}

// 收入审批、审核
export function auditIncome(data) {
  return query(`/zlb/budget/api/income/apply-form/audit`, {
    data,
    method: 'POST',
  });
}
